import React from 'react';

import classNames from 'classnames';

// IB-677 rework — the consistent 5-tile KPI strip shared by every RADIO dashboard.
// Density/cards mirror the shipped Procurement KPI strip (the house standard); the
// lead tile is the dark charcoal treatment with a green label, per the wireframe.
// tiles: [{ label, value, sub?, lead?, tone? }]  — tone ∈ 'red' | 'warn' (value colour).
function Tile({ label, value, sub, lead, tone }) {
    const valueTone = lead ? 'tw-text-white' : tone === 'red' ? 'tw-text-red' : tone === 'warn' ? 'tw-text-red-75' : 'tw-text-charcoal';

    return (
        <div
            className={classNames(
                'tw-flex tw-flex-col tw-gap-2 tw-rounded-lg tw-px-4 tw-py-4',
                lead ? 'tw-bg-charcoal tw-text-white' : 'tw-border-2 tw-border-grey tw-bg-white',
            )}
        >
            <div className={classNames('tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide', lead ? 'tw-text-green' : 'tw-text-charcoal-50')}>{label}</div>
            <div className={classNames('tw-text-2.5xl tw-font-semibold tw-leading-none', valueTone)}>{value}</div>
            {sub != null && sub !== '' && <div className={classNames('tw-text-xs', lead ? 'tw-text-charcoal-25' : 'tw-text-charcoal-75')}>{sub}</div>}
        </div>
    );
}

export default function RadioTileStrip({ tiles }) {
    return (
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-5 tw-gap-3">
            {(tiles || []).map((tile, index) => (
                <Tile key={index} {...tile} />
            ))}
        </div>
    );
}
